<template>
<div class="relatedProducts">
    <el-button v-if="!$store.state.isMobile" size="mini" type="primary" style="width: 100%;margin-bottom: 12px;" @click="toRelatedProducts">查看更多</el-button>
    <ul>
        <li v-for="item in (relatedProduct.length>8?relatedProduct.slice(8):relatedProduct)"
        @click="toProductDetail(item)"
        :key="item.id">
            <img v-if="!$store.state.isMobile" :title="item.name || '产品'" :src="item.thumbnail || '/cdn/images/default/product_thumbnail.png'" alt="">
            <p  v-else><img :title="item.name || '产品'" :src="item.thumbnail || '/cdn/images/default/product_thumbnail.png'" alt=""></p>
            <span>{{(item.name || '产品') | convertStr(9)}}</span>
        </li>
        <li v-if="$store.state.isMobile" class="empty"></li>
        <li v-if="$store.state.isMobile" class="empty"></li>
    </ul>
    <el-button v-if="$store.state.isMobile" size="mini" type="primary" class="more" @click="toRelatedProducts">查看更多</el-button>
</div>
</template>

<script>
    export default {
        props: ['relatedProduct'],
        computed: {
            currentProductInfo() {
                return this.$store.state.currentProductInfo;
            },
        },
        methods: {
            toRelatedProducts() {
                this.$store.commit('relatedProductInfo', {
                    name: this.currentProductInfo.name,
                    productId: this.currentProductInfo.pvId,
                });
                this.$router.push({
                    path: '/related/products',
                });
            },
            toProductDetail(item) {
                // TODO: 当前产品的信息后面统一改为通过productId获取
                // this.$store.commit('currentProductInfo', item);
                const path = `/product/${item.productId}`;
                const { href } = this.$router.resolve({
                    path,
                });
                window.open(href, '_blank');
            },
        },
    };
</script>

<style lang="less" scoped>
    .relatedProducts {
        ul {
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            li {
                width: 22%;
                margin-top: 12px;
                margin-left: 9px;
                height: 80px;
                line-height: 80px;
                background: #fff;
                overflow: hidden;
                text-align: center;
                img {
                    max-width: 100%;
                    max-height: 80px;
                    vertical-align: middle;
                }
            }
        }
    }
</style>
<style lang="less">
@media screen and (max-width: 1120px) {
    .relatedProducts {
        justify-content: space-between !important;
        li{
            width: 80px !important;
            height: initial !important;
            background: initial !important;
            line-height: initial !important;
            margin-bottom: 20px;
            p{
                background: #fff;
                height: 80px;
                line-height: 80px;
                overflow: hidden;
                margin-bottom: 12px;
            }
            span{
                width: 100%;
                color: #fff;
            }
        }
        .more{
            width: 100%;
            margin-top: 32px;
            margin-bottom: 25px;
        }
        .empty{
            opacity: 0;
            height: 0 !important;
        }
    }
}
</style>
